import React from 'react';
import './BlockConfirmDrawer.css';
import blockIcon from '../../assets/block-icon.png';
import blockIconDark from '../../assets/blockdark-icon.png';
import { useTheme } from '../../context/ThemeContext';

function BlockConfirmDrawer({
  isOpen,
  mode = 'block', // 'block' | 'unblock'
  targetUsername = '',
  loading = false,
  onClose,
  onConfirm,
}) {
  const { theme } = useTheme();
  const isDark = theme === 'dark';

  if (!isOpen) return null;

  const isUnblock = mode === 'unblock';
  const iconSrc = isDark ? blockIconDark : blockIcon;

  return (
    <div className="block-confirm-overlay" onClick={loading ? undefined : onClose}>
      <div
        className="block-confirm-popup"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
      >
        <div className="block-confirm-grabber" />

        <div className="block-confirm-icon-wrap">
          <img src={iconSrc} alt="" className="block-confirm-icon" />
        </div>

        <h3>
          {isUnblock ? `Unblock @${targetUsername}?` : `Block @${targetUsername}?`}
        </h3>

        <p>
          {isUnblock
            ? `@${targetUsername} will be able to message you and comment on your posts/stories again.`
            : `@${targetUsername} won’t be able to message you or comment on your posts/stories.`}
        </p>

        <div className="block-confirm-actions">
          <button
            className="block-cancel-btn"
            onClick={onClose}
            disabled={loading}
          >
            Cancel
          </button>

          <button
            className={isUnblock ? 'block-confirm-btn unblock' : 'block-confirm-btn'}
            onClick={onConfirm}
            disabled={loading}
          >
            {loading ? 'Please wait...' : isUnblock ? 'Unblock' : 'Block'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default BlockConfirmDrawer;
